import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";
import { api, errText } from "../../lib/admin";
import { Empty, Loading, Pill, fmtDate } from "./ui";

const Ref = ({ r }) => (
  <article data-testid={`referral-row-${r.code}`} className="bg-white border border-[#e7dfd3] rounded-xl p-5">
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h3 className="font-serif-d text-2xl font-light text-[#14110F]">{r.name}</h3>
        <p className="text-sm text-[#4f4841]">
          <a href={`tel:${r.phone}`} className="underline underline-offset-4">{r.phone}</a>{r.email ? ` · ${r.email}` : ""}
        </p>
      </div>
      <div className="text-right">
        <p className="font-stencil tracking-[0.2em] text-[#8A6A3A]">{r.code}</p>
        <Pill tone={r.friends.length ? "green" : "neutral"} testId={`referral-count-${r.code}`}>{r.friends.length} {r.friends.length === 1 ? "amica" : "amiche"}</Pill>
      </div>
    </div>
    {r.friends.length > 0 && (
      <ul className="mt-4 border-t border-[#efe9df] divide-y divide-[#efe9df] text-sm">
        {r.friends.map((f, i) => (
          <li key={`${f.name}-${i}`} className="py-2 flex flex-wrap justify-between gap-2 text-[#4f4841]">
            <span><strong className="font-medium text-[#14110F]">{f.name}</strong> · {f.service}</span>
            <span className="text-[#6b625a]">{fmtDate(f.created_at)}</span>
          </li>
        ))}
      </ul>
    )}
    <div className="mt-4 flex items-center justify-between text-xs text-[#6b625a]">
      <span>Iscritta il {fmtDate(r.created_at)}</span>
      <a href={`https://wa.me/${(r.phone || "").replace(/\D/g, "").replace(/^(\d{10})$/, "39$1")}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 uppercase tracking-[0.14em] text-[#2f6b3d] hover:underline" data-testid={`referral-wa-${r.code}`}>
        <MessageCircle className="w-4 h-4" /> WhatsApp
      </a>
    </div>
  </article>
);

export const ReferralsAdmin = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/admin/referrals").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch((e) => { toast.error(errText(e)); setItems([]); });
  }, []);
  if (!items) return <Loading />;
  const total = items.reduce((n, r) => n + r.friends.length, 0);
  return (
    <div className="space-y-6" data-testid="admin-referrals">
      <p className="text-[#4f4841]"><strong className="text-[#14110F]">{items.length}</strong> clienti iscritte al programma · <strong className="text-[#14110F]">{total}</strong> amiche hanno prenotato con un codice.</p>
      {items.length ? <div className="grid xl:grid-cols-2 gap-4">{items.map((r) => <Ref key={r.code} r={r} />)}</div>
        : <Empty testId="referral-empty">Nessuna segnalazione per ora.</Empty>}
    </div>
  );
};
